import { GetResponse } from '@customTypes/api/Employee';
import { Endpoints, ServiceAPI } from '@service/index';
import queryKeys from '@src/queries/keys';

import { useQuery } from '../helper/useQuery';

const useGetEmployeeDetail = (enabled = true) => {
  return useQuery<GetResponse>(
    [queryKeys.employeeDetail],
    () =>
      ServiceAPI.get<null, GetResponse>(Endpoints.Employee()).then(
        response => response.data,
      ),
    {
      enabled,
    },
  );
};

export default useGetEmployeeDetail;
